(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["velove-b2b-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-b2b-consent] a').forEach((link) => {
    link.addEventListener('click', (event) => event.stopPropagation());
  });

  const focusTarget =
    document.querySelector('[data-b2b-success]') || document.querySelector('[data-b2b-errors]');

  if (focusTarget) {
    focusTarget.focus({ preventScroll: true });
    focusTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.querySelectorAll('.velove-b2b__form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const trap = form.querySelector('input[name="velove_hp"]');
      if (trap && trap.value.trim() !== '') {
        event.preventDefault();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
